import { render, staticRenderFns } from "./LinkAgeEdit.vue?vue&type=template&id=af10c548&scoped=true&"
import script from "./LinkAgeEdit.vue?vue&type=script&lang=js&"
export * from "./LinkAgeEdit.vue?vue&type=script&lang=js&"
import style0 from "./LinkAgeEdit.vue?vue&type=style&index=0&id=af10c548&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af10c548",
  null
  
)

export default component.exports